var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pc-dream"},[_c('div',{staticClass:"pc-dream-bread"},[_c('h2',[_vm._v("地图列表")]),_vm._v(" "),_c('BreadCrumb',{staticClass:"pc-new-breadcrumb",attrs:{"data":_vm.breadcrumb}})],1),_vm._v(" "),_c('div',{staticClass:"pc-region-table"},[_c('RegionTable',{ref:"uniTable"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-069dcad2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/audit/urbanDream.vue
// module id = CfrV
// module chunks = 0